import React from 'react';
import { DownloadIcon, PrinterIcon, MailIcon, GithubIcon, LinkedinIcon, MapPinIcon, PhoneIcon, BriefcaseIcon, GraduationCapIcon, CodeIcon, AwardIcon } from 'lucide-react';
import { skills } from '../../data/skills';
import { projects } from '../../data/projects';
export const ResumeApp: React.FC = () => {
  const handlePrint = () => {
    window.print();
  };
  return <div className="h-full w-full bg-[#2d2d2d] flex flex-col" data-id="element-94" data-mp="1bn985ygdwz4h">
      {/* Toolbar */}
      <div className="h-12 flex-shrink-0 bg-[#3a3a3a] border-b border-black/30 flex items-center justify-between px-4 text-white text-sm" data-id="element-95" data-mp="1fob68bykf54v">
        <div className="font-semibold" data-id="element-96" data-mp="1kg2taciiisq9">Resume — Emmanuel_Saka.pdf</div>
        <div className="flex items-center gap-2" data-id="element-97" data-mp="1penqs46dqyb0">
          <button onClick={handlePrint} className="flex items-center gap-1.5 px-3 py-1 bg-white/10 hover:bg-white/20 rounded-md text-xs font-medium transition-all hover:-translate-y-0.5" data-id="element-98" data-mp="1pdcne5gujskf">
            <PrinterIcon size={12} data-id="element-99" data-mp="1z9xwp2zwfpu2" /> Print
          </button>
          <button onClick={handlePrint} className="flex items-center gap-1.5 px-3 py-1 bg-blue-500 hover:bg-blue-600 rounded-md text-xs font-medium transition-all hover:-translate-y-0.5" data-id="element-100" data-mp="3plmm136ml5h3">
            <DownloadIcon size={12} data-id="element-101" data-mp="3fnyf7evqw7ik" /> Download PDF
          </button>
        </div>
      </div>

      {/* Resume Document */}
      <div className="flex-1 overflow-y-auto mac-scrollbar bg-[#1e1e1e] py-8 px-4" data-id="element-102" data-mp="c4voif30t604">
        <div className="max-w-3xl mx-auto bg-white text-gray-900 shadow-2xl rounded-sm" style={{
        minHeight: '1000px'
      }} data-id="element-103" data-mp="c6zpao5mhow6">
          {/* Header */}
          <div className="bg-[#1d1d1f] text-white px-10 py-8" data-id="element-104" data-mp="2czdy4jqznf0">
            <h1 className="text-4xl font-bold tracking-tight" data-id="element-105" data-mp="3uimsvgbauc99">Emmanuel Saka</h1>
            <p className="text-blue-300 font-medium text-lg mt-1" data-id="element-106" data-mp="uwoh48e6gp7b">
              Full Stack Developer
            </p>

            <div className="flex flex-wrap gap-x-6 gap-y-2 mt-5 text-xs text-white/80" data-id="element-107" data-mp="q3d8q2tpw0da">
              <span className="flex items-center gap-1.5" data-id="element-108" data-mp="2ke392qioqayt">
                <MailIcon size={12} data-id="element-109" data-mp="2pbll4ps016b1" /> emmanuelsaka333@gmail.com
              </span>
              <span className="flex items-center gap-1.5" data-id="element-110" data-mp="2pdpon6lzk3as">
                <GithubIcon size={12} data-id="element-111" data-mp="2am75x11qrunq" /> github.com/Dev-emmy-001
              </span>
              <span className="flex items-center gap-1.5" data-id="element-112" data-mp="2fl0dkcuckrfz">
                <LinkedinIcon size={12} data-id="element-113" data-mp="21maguybfwts5" /> linkedin.com/in/saka-emmanuel
              </span>
              <span className="flex items-center gap-1.5" data-id="element-114" data-mp="21on3hos57sbj">
                <MapPinIcon size={12} data-id="element-115" data-mp="26m59b6av5rfb" /> Available Remote
              </span>
            </div>
          </div>

          {/* Body */}
          <div className="px-10 py-8 space-y-7 text-sm leading-relaxed" data-id="element-116" data-mp="1rqh4pg1mv2aw">
            {/* Summary */}
            <Section title="Professional Summary" icon={<AwardIcon size={14} data-id="element-118" data-mp="3m2nk6r1k8590" />} data-id="element-117" data-mp="1wp0r1hk52g3s">
              <p className="text-gray-700" data-id="element-119" data-mp="3r1qna5xzc1ec">
                Passionate full-stack developer with hands-on experience
                building modern web applications using React, Node.js, and
                MongoDB. Strong focus on clean architecture, performance, and
                crafting delightful user experiences. Comfortable across the
                entire stack — from designing intuitive interfaces to
                architecting scalable backend APIs.
              </p>
            </Section>

            {/* Skills */}
            <Section title="Technical Skills" icon={<CodeIcon size={14} data-id="element-121" data-mp="1y67hmnt636eu" />} data-id="element-120" data-mp="1y31xzo3b4wqi">
              <div className="grid grid-cols-1 gap-2" data-id="element-122" data-mp="1u3j96h8d81ie">
                {skills.map(cat => <div key={cat.category} className="flex gap-3" data-id="element-123" data-mp="282sshprvbbql">
                    <div className="w-28 font-semibold text-gray-900 flex-shrink-0" data-id="element-124" data-mp="233g4h1p9fymf">
                      {cat.category}
                    </div>
                    <div className="text-gray-700" data-id="element-125" data-mp="dpaypl0vdin4">{cat.items.join(' · ')}</div>
                  </div>)}
              </div>
            </Section>

            {/* Experience */}
            <Section title="Experience" icon={<BriefcaseIcon size={14} data-id="element-127" data-mp="a8om873w5v24" />} data-id="element-126" data-mp="a5kcku7nq742">
              <div className="space-y-5" data-id="element-128" data-mp="f55khu4t1psx">
                <ExperienceItem role="Full Stack Developer" org="Freelance / Open Source" period="2023 — Present" bullets={['Designed and shipped multiple React + Node.js applications serving end users worldwide.', 'Built RESTful APIs with Express and MongoDB, including authentication, rate limiting, and comprehensive error handling.', 'Contributed to open-source projects with focus on developer tooling and UI components.']} data-id="element-129" data-mp="f440v19q3uzl" />
                <ExperienceItem role="Frontend Developer" org="Personal Projects" period="2022 — 2023" bullets={['Built responsive single-page applications with React, TypeScript, and Tailwind CSS.', 'Implemented advanced animations using Framer Motion to create polished, native-feeling UIs.', 'Collaborated with peers via Git and code reviews to ship features on tight timelines.']} data-id="element-130" data-mp="66jxnmsavomc" />
              </div>
            </Section>

            {/* Projects */}
            <Section title="Featured Projects" icon={<CodeIcon size={14} data-id="element-132" data-mp="180d3v8flc337" />} data-id="element-131" data-mp="1d1kbn7hqh29v">
              <div className="space-y-4" data-id="element-133" data-mp="181eifmvtf7po">
                {projects.map(p => <div key={p.id} data-id="element-134" data-mp="137tt0j8afm23">
                    <div className="flex justify-between items-baseline" data-id="element-135" data-mp="137k46yyzbkxz">
                      <div className="font-semibold text-gray-900" data-id="element-136" data-mp="z81ezr04knpc">
                        {p.title}
                      </div>
                      <div className="text-xs text-gray-500 font-mono" data-id="element-137" data-mp="p9lysj2myyum">
                        {p.tech.slice(0, 3).join(' · ')}
                      </div>
                    </div>
                    <p className="text-gray-700 text-xs mt-1" data-id="element-138" data-mp="kclr63q51o1e">
                      {p.description}
                    </p>
                  </div>)}
              </div>
            </Section>

            {/* Education */}
            <Section title="Education" icon={<GraduationCapIcon size={14} data-id="element-140" data-mp="1njo9k4m3p1e" />} data-id="element-139" data-mp="1mqesbe9qlfk">
              <div className="flex justify-between items-baseline" data-id="element-141" data-mp="5ntyj8zft1m2">
                <div data-id="element-142" data-mp="5o3nqucnr4qp">
                  <div className="font-semibold text-gray-900" data-id="element-143" data-mp="tdeh3qrohwut">
                    B.Sc. Computer Science
                  </div>
                  <div className="text-gray-600 text-xs" data-id="element-144" data-mp="ycr205yzotur">
                    University — Self-directed Curriculum
                  </div>
                </div>
                <div className="text-xs text-gray-500" data-id="element-145" data-mp="kj9tdg7ud1ji">2020 — 2024</div>
              </div>
            </Section>

            {/* Footer */}
            <div className="pt-4 mt-6 border-t border-gray-200 text-center text-[10px] text-gray-400 uppercase tracking-widest" data-id="element-146" data-mp="1cc0g903mxdw3">
              References available upon request
            </div>
          </div>
        </div>
      </div>
    </div>;
};
const Section: React.FC<{
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}> = ({
  title,
  icon,
  children
}) => <div data-id="element-147" data-mp="3bixqfro4dk4u">
    <div className="flex items-center gap-2 text-[#1d1d1f] uppercase text-xs font-bold tracking-widest mb-3 pb-1 border-b border-gray-200" data-id="element-148" data-mp="3bjqom490j1bd">
      {icon} {title}
    </div>
    {children}
  </div>;
const ExperienceItem: React.FC<{
  role: string;
  org: string;
  period: string;
  bullets: string[];
}> = ({
  role,
  org,
  period,
  bullets
}) => <div data-id="element-149" data-mp="2dx041j6mcunm">
    <div className="flex justify-between items-baseline" data-id="element-150" data-mp="2dx9sh2c0mtr7">
      <div data-id="element-151" data-mp="2sszirco8ht1q">
        <div className="font-semibold text-gray-900" data-id="element-152" data-mp="2str7q4nbssj1">{role}</div>
        <div className="text-gray-600 text-xs italic" data-id="element-153" data-mp="2ntwc5nslvern">{org}</div>
      </div>
      <div className="text-xs text-gray-500 flex-shrink-0" data-id="element-154" data-mp="2nvzdh3z7kubo">{period}</div>
    </div>
    <ul className="mt-2 ml-4 space-y-1 list-disc text-gray-700 text-xs" data-id="element-155" data-mp="80noyeyb8pgs">
      {bullets.map((b, i) => <li key={i} data-id="element-156" data-mp="35i47jgn9gua" data-mpi={i}>{b}</li>)}
    </ul>
  </div>;